import React, { forwardRef } from 'react';

import { TYPES } from '../constants';

import showPasswordIcon from '../../../assets/images/showPassword.svg';
import hidePasswordIcon from '../../../assets/images/hidePassword.svg';

import { passwordTogglePropsTypes } from '../types';

import * as S from '../styles';

const PasswordToggle = forwardRef<HTMLButtonElement, passwordTogglePropsTypes>(
    ({ disabled, inputType, changeType, isFocus }, ref) => {
        if (isFocus) return null;

        const passwordShowHandler = (e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            e.stopPropagation();

            if (!disabled) {
                const currentType = inputType === TYPES.PASSWORD ? TYPES.TEXT : TYPES.PASSWORD;

                changeType(currentType);
            }
        };

        const Icon = inputType === TYPES.PASSWORD && !disabled ? showPasswordIcon : hidePasswordIcon;

        return (
            <S.TogglePasswordVisibility type="button" tabIndex={-1} ref={ref} onClick={passwordShowHandler}>
                {/* @ts-ignore*/}
                <S.ImgIcon>
                   <Icon />
                </S.ImgIcon>
            </S.TogglePasswordVisibility>
        );
    }
);

export default PasswordToggle;
